// Layout.js
import React from 'react';
import FloatingButtons from '../Common/ContactButton/FloatingButtons';
import Footer from '../../components/Footer/Footer.main';

const LayoutWrapper = ({ children }) => {
  return (
    <div>
      <main>{children}</main>
      <FloatingButtons/>
      {/* <Footer/> */}
    </div>
  );
};

export default LayoutWrapper;
